/* One open FAQ item at a time, within the page (or a single accordion).
   The toggle event does not reach ancestor listeners, so this watches summary clicks. */
(function () {
  'use strict';
  if (window.SwFaqExclusive) return;

  function exclusive(item) {
    if (!item || !item.open) return;
    var scope = item.closest('[data-sw-faq]') || item.closest('.sw-faq') || document;
    var openItems = scope.querySelectorAll('details.sw-faq__item[open]');
    for (var i = 0; i < openItems.length; i++) {
      if (openItems[i] !== item) openItems[i].open = false;
    }
    var page = item.closest('[data-sw-faq]');
    if (page && page.classList.contains('is-searching')) return;
    if (!item.id || !window.history.replaceState) return;
    var next = '#' + item.id;
    if (window.location.hash !== next) window.history.replaceState(null, '', next);
  }

  window.SwFaqExclusive = exclusive;

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('summary');
    if (!summary) return;
    var item = summary.closest('details.sw-faq__item');
    if (!item) return;
    window.setTimeout(function () {
      exclusive(item);
    }, 0);
  });
})();
